import logoPng from "@/assets/images/logos/logo.png";

export const Logo = (props: { className?: string; height?: number }) => {
  return (
    <img
      src={logoPng}
      alt="logo"
      className={props.className}
      style={{ height: props.height || 30 }}
    />
  );
};
